import React from 'react';
import { Settings, Database, Shield } from 'lucide-react';
import { toast } from 'react-hot-toast';

export function AdminSettings() {
  const handleDatabaseReset = async () => {
    // TODO: Implement database reset functionality
    toast.error('Database reset not implemented yet');
  };

  const handleCacheReset = async () => {
    // TODO: Implement cache reset functionality
    toast.error('Cache reset not implemented yet');
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2 mb-4">
          <Database className="w-5 h-5 text-blue-500" />
          Database Management
        </h2>
        
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-sm font-medium text-gray-900">Reset Database</h3>
              <p className="text-sm text-gray-500">Reset the database to its initial state</p>
            </div>
            <button
              onClick={handleDatabaseReset}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
            >
              Reset Database
            </button>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-sm font-medium text-gray-900">Clear Cache</h3>
              <p className="text-sm text-gray-500">Clear all cached data</p>
            </div>
            <button
              onClick={handleCacheReset}
              className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700"
            >
              Clear Cache
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2 mb-4">
          <Shield className="w-5 h-5 text-blue-500" />
          Security Settings
        </h2>
        
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-sm font-medium text-gray-900">API Access</h3>
              <p className="text-sm text-gray-500">Manage API access and keys</p>
            </div>
            <button
              onClick={() => toast.error('API management not implemented yet')}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Manage Keys
            </button>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-sm font-medium text-gray-900">Security Logs</h3>
              <p className="text-sm text-gray-500">View security audit logs</p>
            </div>
            <button
              onClick={() => toast.error('Security logs not implemented yet')}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              View Logs
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}